import { secureRandom } from './randomUtils';
const PERCENT_CHANCE_OF_POWER_PLAYER_UPGRADE_SUGGESTION = 25;
const POWER_PLAYER_UPGRADE_SUGGESTIONS = [
    'Upgrade to Power Player for awesome features!',
    'Power Players can change the look of the room!',
    'Power Players can win the FULL Jackpot!',
    "Power Players can see other players' play styles!",
    'Power Players see "rabbit" cards when the hand ends!',
    'Power Players can use the four-color deck!',
    "Power Players can show off medals they've earned!",
    'Power Players can "auto-reload" chips!',
    'Power Players can play for unique avatars!',
    'Power Players get the Hand History panel!',
    'Power Players can show up in rankings!',
    'Power Players can see stats on themselves and others!',
    'Power Players can play All-Insanity games!'
];
/**
 * If the player is a non-Power Player, there's a chance the server-provided loading message will be overridden by
 * a 'suggestion' to upgrade to Power Player by mentioning a feature they are missing out on.
 */
export function getTransitionAnimationMessage(isPowerPlayer, messageFromServer) {
    if (isPowerPlayer) {
        return { message: messageFromServer, messageType: 'normal' };
    }
    if (secureRandom() > PERCENT_CHANCE_OF_POWER_PLAYER_UPGRADE_SUGGESTION / 100) {
        return { message: messageFromServer, messageType: 'normal' };
    }
    // show a power player upgrade 'suggestion'
    return {
        message: POWER_PLAYER_UPGRADE_SUGGESTIONS[Math.floor(secureRandom() * POWER_PLAYER_UPGRADE_SUGGESTIONS.length)],
        messageType: 'power-player-suggestion'
    };
}
